import { render } from "./reasons-3.vue?vue&type=template&id=f3731f40&scoped=true"
import script from "./reasons-3.vue?vue&type=script&lang=js"
export * from "./reasons-3.vue?vue&type=script&lang=js"

import "./reasons.scss?vue&type=style&index=0&id=f3731f40&scoped=true&lang=scss"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3731f40"]])

export default __exports__